<template>
  <pack>
    <!-- title -->
    <zt-title>
      公告管理
      <zt-button type="primary" @click="showAddDialog" class="btn">发布公告</zt-button>
    </zt-title>

    <!-- 表格 -->
    <el-table class="table" :data="list" v-loading="loading.table" empty-text="-暂无公告-">
      <el-table-column label="id" prop="id"></el-table-column>
      <!-- <el-table-column label="类型" prop="id"></el-table-column> -->
      <el-table-column label="标题" prop="title"></el-table-column>
      <el-table-column label="内容" prop="content" class-name="table-column-content">
        <template slot-scope="{row}">
          <div v-html="getRichTextPreview(row.content)"></div>
        </template>
      </el-table-column>
      <el-table-column label="发送时间" prop="add_time"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <zt-button size="mini" @click="watchDetail(row)">查看</zt-button>
          <zt-button size="mini" @click="del(row)">删除</zt-button>
          <zt-button size="mini" @click="toTop(row)" v-if="row.order_id!=1">置顶</zt-button>
          <zt-button size="mini" @click="cancelTop(row)" v-if="row.order_id==1">取消置顶</zt-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
        :current-page="pagination.page"
        :page-sizes="pagesize"
        :page-size="pagination.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.recordcount"
      ></el-pagination>
    </div>

    <NoticeEditDialog
      :visible.sync="noticeEditProps.visible"
      :form="noticeEditProps.form"
      :mode="noticeEditProps.mode"
      @update="getList">
    </NoticeEditDialog>
  </pack>
</template>

<script>
import {
  admin_public_notice_delete,
  admin_public_notice_list,
  admin_public_notice_set_top,
  admin_public_notice_set_untop
} from '@/api/notice';

import { getRichTextPreview } from '@/filters/richText'
import NoticeEditDialog from '@/views/noticeManage/components/NoticeEditDialog';

export default {
  components: {
    NoticeEditDialog,
  },
  filters: {
    eclipse(str) {
      if (str.length > 15) {
        return str.substring(0, 15) + '...';
      } else {
        return str;
      }
    },
  },
  data: () => ({
    list: [],
    loading: {
      table: false,
    },
    pagesize:[10, 20, 30, 40],
    // 分页器
    pagination: {
      page: 1, // 当前页
      pagesize: 10, // 每页大小
      pagecount: 1, // 总页数
      recordcount: 0, // 总条数
    },
    noticeEditProps: {
      visible: false,
      form: {},
      mode: 'add',
    },
  }),

  computed: {
    // tabs - current
  },
  mounted() {
    this.getList();
  },
  methods: {
    getRichTextPreview,

    //重排数组
    compare() {
      return function(a, b) {
        var val1 = a['order_id'];
        var val2 = b['order_id'];
        if (val1 == null && val2 == null) {
          return 1;
        } else if (val2 == null) {
          return -1;
        } else if (val1 == null) {
          return 1;
        }
        return val1 - val2;
      };
    },

    //获取列表
    getList() {
      this.loading.table = true;
      admin_public_notice_list({
        page: this.pagination.page,
        pagesize: this.pagination.pagesize,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.list = data.list;
          this.list.sort(this.compare());
          this.pagination.pagecount = data.pagecount,
          this.pagination.recordcount = data.recordcount
        } else {
          this.$message.error(data.error_message);
        }
        this.loading.table = false;
      });
    },

    // 更改 - 分页大小
    onSizeChange(pagesize) {
      this.pagination.pagesize = pagesize
      this.getList();
    },

    // 更改 - 当前页
    onCurrentChange(page) {
      this.pagination.page = page
      this.getList();
    },

    //呼出弹层
    showAddDialog() {
      this.noticeEditProps.mode = 'add';
      this.noticeEditProps.visible = true;
    },

    //查看
    watchDetail(row) {
      this.noticeEditProps.mode = 'edit';
      this.noticeEditProps.form = row;
      this.noticeEditProps.visible = true;
    },
    //删除
    del(row) {
      this.$confirm('确认删除公告？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(() => {
        admin_public_notice_delete({
          id: row.id,
        }).then(({ data }) => {
          if (data.error_code == 0) {
            this.$message.success('删除通知成功');
            this.getList();
          } else {
            this.$message.error(data.error_message);
          }
        });
      });
    },

    //置顶
    toTop(row) {
      admin_public_notice_set_top({
        id: row.id,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.$message.success('置顶成功');
          this.getList();
        } else {
          this.$message.error(data.error_message);
        }
      });
    },

    //取消置顶
    cancelTop(row) {
      admin_public_notice_set_untop({
        id: row.id,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.$message.success('取消置顶成功');
          this.getList();
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
@import "~@/styles/mixin.scss";

// 主图
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background: #f7f2ff
}
.table {
  margin-top: 8px;
}
.btn {
  float: right;
}
// table column style
/deep/ .table-column-content .cell{
  @include elip(2);
}
</style>
